import { graphql } from '~/gql'

export const GET_USER_PERMISSIONS_QUERY = graphql(`
  query GetUserAllPermissions($auth0UserId: String, $id: ID) {
    User(auth0UserId: $auth0UserId, id: $id) {
      id
      permissions {
        id
        name
        deleted
      }
      roles {
        id
        name
      }
    }
  }
`)
